import { useNavigate } from "react-router-dom";

function PopupModal({ show, onClose }) {
  const navigate = useNavigate();

  if (!show) return null;

  return (
    <div className="custom-modal" onClick={onClose}>
      
      {/* STOP click propagation */}
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>

        {/* Header */}
        <div className="modal-header">
          <span>Select Option</span>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        {/* Body */}
        <div className="modal-body">
          <button 
            className="btn btn-primary option-btn"
            onClick={() => {
              navigate("/Login");
              onClose();
            }}
          >
            🎓 Competitive Exam
          </button>

          <button 
            className="btn btn-success option-btn"
            onClick={() => {
              navigate("/Drlogin");
              onClose();
            }}
          >
            🩺 Doctor Listing
          </button>
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>

      </div>
    </div>
  );
}

export default PopupModal;